import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";

// Globally enrich edge-function error messages so UI toasts show the real
// server reason instead of "Edge Function returned a non-2xx status code".
import { patchSupabaseInvoke } from "./lib/patchSupabaseInvoke";
import { supabase } from "./integrations/supabase/client";
import { adminSupabase } from "./integrations/supabase/adminClient";
import { baasSupabase } from "./integrations/supabase/baasClient";
import { pmSupabase } from "./integrations/supabase/pmClient";
patchSupabaseInvoke(supabase);
patchSupabaseInvoke(adminSupabase);
patchSupabaseInvoke(baasSupabase);
patchSupabaseInvoke(pmSupabase);

createRoot(document.getElementById("root")!).render(<App />);
